import { createColumnHelper } from '@tanstack/react-table';
import { EnterpriseRelationshipOverviewEntry } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { EnterpriseLink } from '@mews-commander/ui';
import { RowActionMenu } from './RowActionMenu';

const columnHelper = createColumnHelper<EnterpriseRelationshipOverviewEntry>();

export const useColumns = (ownerId: string, portfolioName: string) => [
    columnHelper.accessor('name', {
        header: () => lt('Name'),
        cell: (props) => {
            const value = props.getValue();
            const { enterpriseId } = props.row.original;
            return (
                <EnterpriseLink
                    standalone
                    variant="basic"
                    to="Enterprise/Detail/$enterpriseId"
                    params={{ enterpriseId }}
                    search={{ PortfolioId: ownerId }}
                >
                    {value}
                </EnterpriseLink>
            );
        },
    }),
    columnHelper.accessor('uniqueName', {
        header: () => lt('UniqueName'),
    }),
    columnHelper.accessor('enterpriseType', {
        header: () => lt('Type'),
    }),
    columnHelper.accessor('creatorProfileEmail', {
        header: () => lt('AddedBy'),
    }),
    columnHelper.display({
        id: 'actions',
        meta: { align: 'end' },
        cell: ({
            row: {
                original: { id, name },
            },
        }) => <RowActionMenu id={id} propertyName={name} portfolioName={portfolioName} ownerId={ownerId} />,
    }),
];
